var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { FullTermsConditionsLink, TermsConditionText, TermsConditionTextWrapper } from './subcomponents';
import { TEXT_ALERTS_TERMS_AND_CONDITIONS } from '../../../const/alertsConfig';
import SyfStorage from '../../../helpers/SyfStorage';
import { useAlerts } from '../../customHooks';
var TermsConditionsBody = function () {
    var _a;
    var t = useTranslation().t;
    var config = useAlerts().appConfig.config;
    var TERMS_CONDITIONS_LINK = t('termsAndConditions.linkLabel');
    var CONTENT_BEFORE_LINK = t('termsAndConditions.contentBeforeLink');
    var CONTENT_AFTER_LINK = t('termsAndConditions.contentAfterLink');
    var currentLanguage = SyfStorage.getLanguage();
    var ASSET_HOST = (_a = config === null || config === void 0 ? void 0 : config.hosts) === null || _a === void 0 ? void 0 : _a.assets;
    var termsConditionsHtmlPath = currentLanguage === 'es'
        ? TEXT_ALERTS_TERMS_AND_CONDITIONS.ES || ''
        : TEXT_ALERTS_TERMS_AND_CONDITIONS.EN || '';
    return (_jsx(TermsConditionTextWrapper, __assign({ className: "tc-text", "data-test": "TermsConditionTextWrapper" }, { children: _jsxs(TermsConditionText, __assign({ "data-test": "TermsConditionText", isInline: true }, { children: [CONTENT_BEFORE_LINK, _jsx(FullTermsConditionsLink, __assign({ isInline: true, target: "_blank", href: ASSET_HOST + termsConditionsHtmlPath }, { children: TERMS_CONDITIONS_LINK })), CONTENT_AFTER_LINK] })) })));
};
export default TermsConditionsBody;
